/**
 * @file Builds the profile-type radio options, each with its label and
 * extra description.
 */
import { Space, Typography } from "antd";

import {
  INVESTMENT_PROFILE_TYPE_JOINT,
  INVESTMENT_PROFILE_TYPE_SDIRA,
  INVESTMENT_PROFILE_TYPE_ENTITY,
  INVESTMENT_PROFILE_TYPE_INDIVIDUAL,
} from "@components/Domain";
import { Small } from "@components/Text";

import type { Option } from "../types";

const { Text } = Typography;

const LABEL_INDIVIDUAL = "Yourself as an individual";
const LABEL_INDIVIDUAL_EXISTS = " (already exists)";
const LABEL_JOINT = "Yourself and your spouse or tenancy";
const LABEL_ENTITY = "Entity / Trust";
const LABEL_SDIRA = "SDIRA";

const EXTRA_ENTITY = `
  Including LLCs, corporations, trusts, exempt organizations, and other
  retirement plans
`;

const EXTRA_SDIRA = `
  Including SDIRAs with checkbook control
`;

const OPTION_STYLE = { lineHeight: 1.2 };

/**
 * Builds the profile-type options, marking the individual option
 * disabled when the investor already has one.
 */
const renderProfileTypeOptions = (isIndividualDisabled = false): Option[] => {
  const individualLabel = isIndividualDisabled
    ? `${LABEL_INDIVIDUAL}${LABEL_INDIVIDUAL_EXISTS}`
    : LABEL_INDIVIDUAL;

  return [
    {
      value: INVESTMENT_PROFILE_TYPE_INDIVIDUAL,
      label: individualLabel,
      disabled: isIndividualDisabled,
    },
    {
      value: INVESTMENT_PROFILE_TYPE_JOINT,
      label: LABEL_JOINT,
    },
    {
      value: INVESTMENT_PROFILE_TYPE_ENTITY,
      label:
        <Space direction="vertical" size={0} style={OPTION_STYLE}>
          <Text>{LABEL_ENTITY}</Text>
          <Small>{EXTRA_ENTITY}</Small>
        </Space>,
    },
    {
      value: INVESTMENT_PROFILE_TYPE_SDIRA,
      label:
        <Space direction="vertical" size={0} style={OPTION_STYLE}>
          <Text>{LABEL_SDIRA}</Text>
          <Small>{EXTRA_SDIRA}</Small>
        </Space>,
    },
  ];
};

export default renderProfileTypeOptions;
